<template>
    <div class="NewCommunityFamily container-fluid">

        <!--CREATE NEW TRANSACTION-->
        <b-modal ref="modal-component" size="lg" title="Add New Community Family" hide-footer>
            <b-container>
                <b-form @submit="SaveRecord">
                    <b-row>
                        <b-col>
                            <h4>General Info</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Family Name (Last Name, First Names of Caregivers):</label>
                                <input placeholder="Last, First(s)" v-model="TargetRecord.Name" required class="form-control" />
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Territory:</label>
                                <select v-model="TargetRecord.SubProgramTerritoryID" required class="form-control">
                                    <option v-for="option in SubProgramTerritoryOptions" :value="option.value">{{option.text}}</option>
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h4>Address</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Physical Address:</label>
                                <input type="text" v-model="TargetRecord.PhysicalAddressLine1" class="form-control" placeholder="Address Line 1" />
                                <input type="text" v-model="TargetRecord.PhysicalAddressLine2" class="form-control" placeholder="Address Line 2 (optional)" />
                                <b-row>
                                    <div class="col-5 no-padding">
                                        <input type="text" v-model="TargetRecord.PhysicalCity" class="form-control" placeholder="City" />
                                    </div>
                                    <div class="col-3 no-padding">
                                        <select class="form-control" v-model="TargetRecord.PhysicalStateAbbreviation">
                                            <option v-for="option in StateOptions" :value="option.value">
                                                {{option.text}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-4 no-padding">
                                        <input type="text" v-model="TargetRecord.PhysicalZipCode" class="form-control" placeholder="Zip" />
                                    </div>
                                </b-row>
                                <div class="form-group">
                                    <label>County:</label>
                                    <v-select :options="CountyOptions" label="text" :reduce="option => option.value" v-model="TargetRecord.County"></v-select>
                                </div>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Mailing Address: <font-awesome-icon :icon="['fa', 'robot']" @click="CopyPhysicalAddress()" class="pointer" /></label>
                                <input type="text" v-model="TargetRecord.MailingAddressLine1" class="form-control" placeholder="Address Line 1" />
                                <input type="text" v-model="TargetRecord.MailingAddressLine2" class="form-control" placeholder="Address Line 2 (optional)" />
                                <b-row>
                                    <div class="col-5 no-padding">
                                        <input type="text" v-model="TargetRecord.MailingCity" class="form-control" placeholder="City" />
                                    </div>
                                    <div class="col-3 no-padding">
                                        <select class="form-control" v-model="TargetRecord.MailingStateAbbreviation">
                                            <option v-for="option in StateOptions" :value="option.value">
                                                {{option.text}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-4 no-padding">
                                        <input type="text" v-model="TargetRecord.MailingZipCode" class="form-control" placeholder="Zip" />
                                    </div>
                                </b-row>
                            </div>

                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h4>Relationship</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Olive Crest Relationship Started:</label>
                                <flat-pickr v-model="TargetRecord.StartDate" class="form-control" :config="DateConfig" required></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="HideModal()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    import SelectFromEndpoint from '../../../Core/CustomInputElements/SelectFromEndpoint.vue';

    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faChurch } from '@fortawesome/free-solid-svg-icons';
    library.add(faChurch);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);

    
    export default {
        name: "NewCommunityFamily",
        created() {
 
        },
        props: [],
        data: function () {
            return {
                //AUX
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false,
                },
                TargetRecord: {},
                PreFillReferralID: null
            };
        },
        methods: {
            //API
            SaveRecord(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "StrongFamilies/CommunityFamilies", this.TargetRecord, this.SaveRecordSuccess, () => { }, true);
            },
            SaveRecordSuccess(response) {
                this.$emit("updatetable");
                if (this.PreFillReferralID != null) {
                    this.$emit("newprefilladded",
                        {
                            ReferralID: this.PreFillReferralID,
                            CommunityFamilyID: response.data.data.Id,
                            CommunityFamilyName: response.data.data.Name,
                            CommunityFamilyTerritoryName: response.data.data.SubProgramTerritory.Name,
                            CommunityFamilyCity: response.data.data.PhysicalAddress.City
                        });
                }
                this.HideModal();
            },
            //UI
            ShowModal() {
                this.PreFillReferralID = null;
                this.TargetRecord = {
                    PhysicalAddressLine1: "",
                    PhysicalAddressLine2: "",
                    PhysicalCity: "",
                    PhysicalStateAbbreviation: "",
                    PhysicalZipCode: ""
                };
                this.$refs['modal-component'].show();
            },
            ShowModalWithPreFillData(name, addressLine1, addressLine2, city, state, zip, territoryId, startDate, referralID) {
                this.PreFillReferralID = referralID;
                this.TargetRecord = {
                    Name: name,
                    PhysicalAddressLine1: addressLine1,
                    PhysicalAddressLine2: addressLine2,
                    PhysicalCity: city,
                    PhysicalStateAbbreviation: state,
                    PhysicalZipCode: zip,
                    MailingAddressLine1: addressLine1,
                    MailingAddressLine2: addressLine2,
                    MailingCity: city,
                    MailingStateAbbreviation: state,
                    MailingZipCode: zip,
                    SubProgramTerritoryID: territoryId,
                    StartDate: startDate
                };
                this.$refs['modal-component'].show();
            },
            HideModal() {
                this.$refs['modal-component'].hide();
            },
            CopyPhysicalAddress() {
                this.TargetRecord.MailingAddressLine1 = this.TargetRecord.PhysicalAddressLine1;
                this.TargetRecord.MailingAddressLine2 = this.TargetRecord.PhysicalAddressLine2;
                this.TargetRecord.MailingCity = this.TargetRecord.PhysicalCity;
                this.TargetRecord.MailingStateAbbreviation = this.TargetRecord.PhysicalStateAbbreviation
                this.TargetRecord.MailingZipCode = this.TargetRecord.PhysicalZipCode;
                this.$forceUpdate();
            },
            //AUX
            formatDate(value, fmt = 'MM/DD/YY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            }
        },
        components: {
            flatPickr,
            vSelect,
            SelectFromEndpoint
        },
        computed: {
            StateOptions: function () {
                return [
                    {
                        text: "California",
                        value: "CA"
                    },
                    {
                        text: "Nevada",
                        value: "NV"
                    },
                    {
                        text: "Washington",
                        value: "WA"
                    }
                ];
                
            },
            CountyOptions: function () {
                return this.$store.state.Options.CaliforniaCounties;
            },
            SubProgramTerritoryOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramTerritoryOptions"]();
            },
        },
        mounted() {
            
        }
    }
</script>

<style scoped>
</style>